export const BreGuidesRate = {
  PDF: '400',
};
